'use client';
import { createContext, useContext } from 'react';
const ComputerAskInputLocalModeContext = createContext(undefined);
export const ComputerAskInputLocalModeProvider = ComputerAskInputLocalModeContext.Provider;
export function useComputerAskInputLocalMode() {
    return useContext(ComputerAskInputLocalModeContext);
}
//# sourceMappingURL=ComputerAskInputLocalMode.js.map